import type { Website } from '@ps/web-martech-cms-types';

export interface MenuItem {
  name: string;
  url: string;
}

export const menuItemsPrototype4: MenuItem[] = [
  { name: 'Spin & Go', url: '/poker/play-poker/spin-and-go/' },
  { name: 'Cash Games', url: '/poker/play-poker/cash-games/simple/' },
  { name: 'Tournaments', url: '/poker/play-poker/tournaments/' },
  { name: 'All-In Poker', url: '/poker/play-poker/cash-games/all-in/' }
];

export const menuItemsPrototype3: MenuItem[] = [
  { name: 'Cash Games', url: '/poker/play-poker/cash-games/simple/' },
  { name: 'Power Path', url: '/poker/play-poker/power-path/' },
  { name: 'Spin & Go', url: '/poker/play-poker/spin-and-go/' },
  { name: 'Tournaments', url: '/poker/play-poker/tournaments/' },
  { name: 'Home Games', url: '/homegames/' },
  { name: 'All-In Poker', url: '/poker/play-poker/cash-games/all-in/' }
];

const EXCLUDED_MENU_ITEMS_PT = ['Cash Games', 'All-In Poker'];

const filterMenuItemsBySite = (items: MenuItem[], site?: Website['site']): MenuItem[] => {
  if (site === 'PT') {
    return items.filter((item) => !EXCLUDED_MENU_ITEMS_PT.includes(item.name));
  }
  return items;
};

export const getMenuItemsPrototype3 = (site?: Website['site']): MenuItem[] =>
  filterMenuItemsBySite(menuItemsPrototype3, site);

export const getMenuItemsPrototype4 = (site?: Website['site']): MenuItem[] =>
  filterMenuItemsBySite(menuItemsPrototype4, site);
